export default __webpack_public_path__ + "b9db7177f9b2fb28b11d8ecbff464a73.svg";